// =========================================================================================================================
// Arabic: ربي يسر ولا تعسر ,و تمم بالخير
// English: O my Lord, make this task easy for me, and do not make it difficult for me and let my affairs end with goodness.
// Code Author: Muhammad Muashir uddin
// =========================================================================================================================
export class RangeSlider extends EventTarget {
  constructor(id, label, min, max, value, unit, width) {
    super();    
    this.minimum = min;
    this.maximum = max;
    this.u = unit;
    this.slider = document.createElement("div");
    this.slider.id = id;
    this.slider.classList.add("slider");

    let lbl = document.createElement("div");
    lbl.classList.add("sliderLabel");
    lbl.innerText = label + ":";
    this.slider.appendChild(lbl);

    this.val = document.createElement("div");
    this.val.classList.add("sliderVal");
    this.val.style.width = width;
    this.val.innerText = value + " " + unit;
    this.slider.appendChild(this.val);

    this.range = document.createElement("div");
    this.range.style.position = "relative";
    this.range.style.marginLeft = "5px";
    this.range.style.height = "3vh";
    this.range.style.display = "flex";
    this.range.style.justifyContent = "center";
    this.range.style.alignItems = "center";

    this.w = 0;

    setTimeout(() => {
      let b = this.val.getBoundingClientRect();
      this.range.style.width = "calc(100% - " + (b.x + b.width) + "px)";
      this.w = window.innerWidth - b.x - b.width;
    }, 0);

    let line = document.createElement("div");
    line.style.width = "calc(100% - 30px)";
    line.style.height = "1px";
    line.style.background = "#999999";
    this.range.appendChild(line);

    this.slider.appendChild(this.range);

    this.dot = document.createElement("div");
    this.dot.id = "dot";
    this.dot.style.position = "absolute";
    this.dot.style.background = "#4caf50";
    this.dot.style.borderRadius = "50%";
    this.dot.style.width = this.dot.style.height = "2.5vh";
    this.dot.style.left = 0;
    this.range.appendChild(this.dot);

    let isTouching = false;

    const onTouchStart = (e) => {
      isTouching = true;
      const touch = e.touches[0];      
    };

    const onTouchMove = (e) => {
      if (!isTouching) return;
      e.preventDefault(); 
      const touch = e.touches[0];
      const x = touch.clientX;

      const rect = this.range.getBoundingClientRect();
      const dotWidth = this.dot.offsetWidth;

      let relativeX = x - rect.left - dotWidth / 2;

      const minX = 0;
      const maxX = rect.width - dotWidth;
      relativeX = Math.max(minX, Math.min(relativeX, maxX));

      this.dot.style.left = `${relativeX}px`;

      const percent = relativeX / maxX;
      const currentValue = Math.round(min + percent * (max - min));
      this.val.innerText = currentValue + " " + this.u;

      this.dispatchEvent(new CustomEvent("change", { detail: {
        id: id,
        value: currentValue
      }}));
    };

    const onTouchEnd = (e) => {
      if (!isTouching) return;
      isTouching = false;
      const touch = e.changedTouches[0];
    };

    this.dot.addEventListener("touchstart", onTouchStart, { passive: false });
    window.addEventListener("touchmove", onTouchMove, { passive: false });
    window.addEventListener("touchend", onTouchEnd);    
    setTimeout(() => {
      this.setValue(value);      
    }, 1000);
  }
  setValue(v) {
    this.val.innerText = v + " " + this.u;
    const rangeRect = this.range.getBoundingClientRect();
    const dotWidth = this.dot.offsetWidth;
    const availableWidth = rangeRect.width - dotWidth;
    const percent = (v - this.minimum) / (this.maximum - this.minimum);
    const position = percent * availableWidth;
    this.dot.style.left = `${position}px`;
  }
  appendTo(parent) {
    if (parent instanceof HTMLElement) {
      parent.appendChild(this.slider);
    } else {
      console.error("Invalid parent element. It must be an HTMLElement.");
    }
  }
}
